import { CircleAlert } from '@tamagui/lucide-icons';
import { Stack } from 'tamagui';
import { tokens } from 'tamagui-config';

export const WarningIcon: React.FC = () => (
  <Stack
    width={288}
    height={288}
    borderRadius={9999}
    borderWidth={1}
    borderColor="rgba(255, 255, 255, 0.05)"
    backgroundImage="linear-gradient(231.68deg, rgba(188, 209, 224, 0.1) 34.15%, rgba(0, 0, 0, 0.1) 64.88%)"
    alignItems="center"
    justifyContent="center">
    <CircleAlert size={133} color={tokens.color.warningRed} />
  </Stack>
);
